import { render } from "./NewAdvisorFormComponent.vue?vue&type=template&id=38baf7b2&scoped=true"
import script from "./NewAdvisorFormComponent.vue?vue&type=script&lang=js"
export * from "./NewAdvisorFormComponent.vue?vue&type=script&lang=js"

import "./NewAdvisorFormComponent.vue?vue&type=style&index=0&id=38baf7b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38baf7b2"]])

export default __exports__